import IntegrationsList from "./IntegrationsList";

export default IntegrationsList;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/order_integrations/integrations-list/index.js